export default "<h1>My Products</h1>\n\n<div class=\"table\">\n    <product-list [isAdmin]=\"false\"></product-list>\n</div>\n"